import { StdResponse, request } from "@/global/config/request";
import { MonitorObject } from "@/global/interface/monitor-object/monitor-object";


/**
  * 获得监测对象列表
  * 
  * @param projectId 项目id
  */
export function getMonitorObjectsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-objects`, {
        params: {
            ...params,
        }
    })
}
/**
  * 获得监测对象列表，含根监测参数
  * 
  * @param projectId 项目id
  */
export function getMonitorObjectWithParamsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-objects/params`, {
        params: {
            ...params,
        }
    })
}

export function getMonitorObjectsBySensorId(projectId: number, sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-objects/sensors/${sensorId}`, {
        params: {
            ...params,
        }
    })
}

/**
  * 获得监测对象列表，含根监测参数和直接参数
  * 
  * @param projectId 项目id
  */
export function getMonitorObjectWithParamDqsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-objects/param-dqs`, {
        params: {
            ...params,
        }
    })
}

/**
   * 获得监测对象详情
   * 
   * @param id 监测对象id
   */
export function getMonitorObjectById(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/monitor-objects/${id}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 新增监测对象
 * 
 * @param projectId 项目id
 * @param data      监测对象数据
 */
export function addMonitorObject(projectId: number, data: MonitorObject, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/monitor-objects`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除监测对象
 * 
 * @param id 监测对象id
 */
export function deleteMonitorObjectById(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/monitor-objects/${id}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 编辑监测对象
 * 
 * @param id   监测对象id
 * @param data 监测对象数据
 */
export function updateMonitorObject(id: number, data: MonitorObject, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/monitor-objects/${id}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获得监测对象图元
 * 
 * @param uuid 监测对象图元uuid
 */
export function getMonitorObjectEntityByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/monitor-object-entity/${uuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获得项目里的所有监测对象图元
 * 
 * @param projectId 项目id
 */
export function getMonitorObjectEntitiesByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/monitor-object-entity`, {
        params: {
            ...params,
        }
    })
}
